import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../redux/root-reducer';
import rootSaga from '../redux/root-saga';
import getMiddlewares from '../_middlewares/middlewares';

const sagaMiddleware = createSagaMiddleware();

const middlewares = getMiddlewares();
middlewares.push(sagaMiddleware);

// In development, use the browser's Redux dev tools extension if installed
const enhancers = [];
const isDevelopment = process.env.NODE_ENV === 'development';

if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
	enhancers.push(window.devToolsExtension());
}

export const store = createStore(rootReducer, compose(applyMiddleware(...middlewares), ...enhancers));

// Mount rootSaga must be done after applyMiddleware
sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

export default { store, persistStore };
